import Typography from '@/shared/ui/typography/Text';

import { useLoadingText } from './useLoadingText';

const LoadingText = ({ firstChunkArrived }: { firstChunkArrived: boolean }) => {
  const { text } = useLoadingText(firstChunkArrived);

  if (!text) return null;

  return (
    <Typography
      sx={{
        fontSize: '14px',
        color: 'gx.textDisabled',
        fontWeight: 500,
        mb: '8px',
        display: 'inline-block',
        '&::after': {
          '@keyframes loadingDots': {
            '0%': { width: 0 },
            '100%': { width: '12px' }
          },
          content: '"..."',
          display: 'inline-block',
          overflow: 'hidden',
          width: 0,
          animation: 'loadingDots 1.5s steps(4, end) infinite',
          verticalAlign: 'bottom'
        }
      }}
    >
      {text}
    </Typography>
  );
};

export default LoadingText;
